"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const RoomCardMolecules_1 = require("../RoomCardMolecules");
const RoomCardAtoms_1 = require("../RoomCardAtoms");
function default_1({ publisher_uid, publisher_thumbnail, publisher_name, storyViewUrl, title, maxWidth768, isMasonryMobile, }) {
    return ((0, jsx_runtime_1.jsxs)(RoomCardAtoms_1.CardBottomWrapper, { children: [(0, jsx_runtime_1.jsx)(RoomCardMolecules_1.ChannelLink, { channel_uid: publisher_uid, channel_thumbnail: publisher_thumbnail, channel_name: publisher_name }), (0, jsx_runtime_1.jsx)(RoomCardAtoms_1.Title, { viewUrl: storyViewUrl, title: title, maxWidth768: maxWidth768, isMasonryMobile: isMasonryMobile })] }));
}
exports.default = default_1;
